import { Component } from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, FormArray, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient} from '../../../services/http.service';
import {DatePipe} from '@angular/common';
import {TemplateService} from '../../../services/template.service';
import {GoBackButtonService} from '../../../services/go-back-button.service';
import {NotificationService} from '../../../services/notification.service';
import {BreadcrumbsService} from '../../../shared/breadcrumbs/services';

@Component({
    selector: 'app-condition-lifecycle',
    templateUrl: './condition-lifecycle.component.html',
    styleUrls: [
        './condition-lifecycle.component.scss',
    ],
    standalone: false
})
export class ConditionLifecycleComponent {
  public form: UntypedFormGroup;
  public text: any;
  public developerId: any;
  public developerCaption: any;
  public conditionId: any;
  public allComplexes: any[] = [];
  public mode: 'create' | 'edit' = 'create';
  public oldText: any;

  txt_spn = 'Вознаграждение агента (ДДУ), %';
  txt_sa = 'Вознаграждение СА (АГД), %';

  get complexes(): FormArray {
    return this.form.get('complexes') as FormArray;
  }

  get settings(): FormArray {
    return this.form.get('settings') as FormArray;
  }

  constructor(
    private fb: UntypedFormBuilder,
    public goBack: GoBackButtonService,
    private b: BreadcrumbsService,
    private template: TemplateService,
    public activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private datePipe: DatePipe,
    public router: Router,
    public notify: NotificationService
  ) { }

  ngOnInit() {
    const conditionId = this.activatedRoute.snapshot.params['conditionId'];
    const developerId = this.activatedRoute.snapshot.params['developerId'];

    this.developerId = Number(developerId);
    this.conditionId = conditionId ? Number(conditionId) : null;

    this.http.post('Condition.get_developer_caption', { developer_id: this.developerId })
      .subscribe((data: any) => {
        let mode = 'Создание';

        this.developerCaption = typeof data === 'string' ? data : data?.caption || '';
        if (this.conditionId) {
          mode = 'Редактирование';
        }

        if (this.developerCaption) {
          this.goBack.header = '<h2>' + mode + ' УВ и КВ ' + this.developerCaption + '</h2>';
          this.b.set([
            {url: '/index', caption: 'Главная'},
            {url: '/condition/developer', caption: 'Условия реализации и КВ'},
            {url: '/condition/developer/' + this.developerId, caption: 'Условия реализации застройщика'},
          ]);
          this.template.setHeader(mode + ' условий реализации и КВ ' + this.developerCaption);
        }
      });

    this.uploadData();
  }

  setDefaultDates(): void {
    const today = new Date();
    const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    const formattedToday = this.datePipe.transform(today, 'dd.MM.yyyy');
    const formattedLastDay = this.datePipe.transform(lastDayOfMonth, 'dd.MM.yyyy');

    this.form.get('date_from').setValue(formattedToday);

    this.form.get('date_to').setValue(formattedLastDay);
  }

  uploadData() {
    this.http.post('Condition.get_complexes_developer', {
      'developer_id': this.developerId
    }).subscribe((complexes: any[]) => {
      this.allComplexes = complexes;

      if (this.conditionId) {
        this.mode = 'edit';
        this.http.post('Condition.get_condition', {
          'condition_id': this.conditionId
        })
          .subscribe((data: any) => {
            this.initForm();
            this.patchForm(data);
          });
      } else {
          this.http.post('Condition.get_old_condition_text', {
            'developer_id': this.developerId
          })
            .subscribe((data: any) => {
              if (data) {
                this.oldText = data;
              }
              this.initForm();
              this.mode = 'create';
              this.setDefaultDates();
              this.initEmptyComplexes();
            });
        }
    });
  }

  initForm(): void {
    this.form = this.fb.group({
      date_from: [null, Validators.required],
      date_to: [null, Validators.required],
      flat_agent_remuneration: [null],
      flat_agent_remuneration_share: [null],
      commercial_agent_remuneration: [null],
      commercial_agent_remuneration_share: [null],
      condition_text: [this.oldText || null, Validators.required],
      is_condition_check_disabled: [false],
      complexes: this.fb.array([]),
      settings: this.fb.array([]),
    });
  }

  initEmptyComplexes(): void {
    if (this.allComplexes && this.allComplexes.length > 0) {
      this.allComplexes.forEach(complex => {
        this.complexes.push(this.fb.group({
          id: [complex.id],
          caption: [complex.caption],
          is_checked: [true],
        }));
        this.settings.push(this.fb.group({
          flat_agent_remuneration: [null],
          flat_agent_remuneration_share: [null],
          commercial_agent_remuneration: [null],
          commercial_agent_remuneration_share: [null],
        }));
      });
    }
  }

  patchForm(data: any): void {
    this.form.patchValue({
      date_from: data.date_from,
      date_to: data.date_to,
      flat_agent_remuneration: data.flat_agent_remuneration,
      flat_agent_remuneration_share: this.calculatePercentFromShare(
        data.flat_agent_remuneration_share,
        data.flat_agent_remuneration
      ),
      commercial_agent_remuneration: data.commercial_agent_remuneration,
      commercial_agent_remuneration_share: this.calculatePercentFromShare(
        data.commercial_agent_remuneration_share,
        data.commercial_agent_remuneration
      ),
      condition_text: data.text,
      is_condition_check_disabled: data.is_condition_check_disabled,
    });

    // Обработка комплексов и их уникальных настроек
    const all = data.complexes || [];
    const individual = data.complexes_unique || [];

    all.forEach(complex => {
      this.complexes.push(this.fb.group({
        id: [complex.id],
        caption: [complex.caption],
        is_checked: [!!complex.is_checked],
      }));

      const specific = individual.find((i: any) => i.id === complex.id);

      const flatAgentRem = specific?.flat_agent_remuneration || null;
      const flatShare = specific?.flat_agent_remuneration_share || null;
      const flatPercent = this.calculatePercentFromShare(flatShare, flatAgentRem);

      const commAgentRem = specific?.commercial_agent_remuneration || null;
      const commShare = specific?.commercial_agent_remuneration_share || null;
      const commPercent = this.calculatePercentFromShare(commShare, commAgentRem);

      this.settings.push(this.fb.group({
        flat_agent_remuneration: [flatAgentRem],
        flat_agent_remuneration_share: [flatPercent],
        commercial_agent_remuneration: [commAgentRem],
        commercial_agent_remuneration_share: [commPercent],
      }));
    });
  }

  preparePayload(): any {
    const formValue = this.form.value;

    const normalize = (val: any): number => {
      if (typeof val === 'string') {
        val = val.replace(',', '.');
      }
      const parsed = parseFloat(val);
      return isNaN(parsed) ? null : parsed;
    };

    const calculateRatio = (percent: any, base: any): number => {
      const p = normalize(percent);
      const b = normalize(base);
      if (!p || !b) { return null; }
      return +(p / b).toFixed(5);
    };

    const complexes: any[] = [];
    const complexes_unique: any[] = [];

    formValue.complexes.forEach((complex: any, index: number) => {
      const setting = formValue.settings[index];
      complexes.push({ id: complex.id });

      if (!complex.is_checked) {
        complexes_unique.push({
          id: complex.id,
          flat_agent_remuneration: normalize(setting.flat_agent_remuneration),
          flat_agent_remuneration_share: calculateRatio(
            setting.flat_agent_remuneration_share,
            setting.flat_agent_remuneration
          ),
          commercial_agent_remuneration: normalize(setting.commercial_agent_remuneration),
          commercial_agent_remuneration_share: calculateRatio(
            setting.commercial_agent_remuneration_share,
            setting.commercial_agent_remuneration
          ),
        });
      }
    });

    return {
      date_from: formValue.date_from,
      date_to: formValue.date_to,
      flat_agent_remuneration: normalize(formValue.flat_agent_remuneration),
      flat_agent_remuneration_share: calculateRatio(
        formValue.flat_agent_remuneration_share,
        formValue.flat_agent_remuneration
      ),
      commercial_agent_remuneration: normalize(formValue.commercial_agent_remuneration),
      commercial_agent_remuneration_share: calculateRatio(
        formValue.commercial_agent_remuneration_share,
        formValue.commercial_agent_remuneration
      ),
      text: formValue.condition_text,
      is_condition_check_disabled: formValue.is_condition_check_disabled,
      complexes,
      complexes_unique,
    };
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.onError('Заполните обязательные поля');
      return;
    }

    const payload = this.preparePayload();
    const method = this.mode === 'edit'
      ? 'Condition.edit_developer_condition'
      : 'Condition.set_developer_condition';

    const params = this.mode === 'edit'
      ? [this.conditionId, payload]
      : [this.developerId, payload];

    this.http.post(method, params).subscribe(() => {
      this.onSuccess('Данные успешно записаны');
      this.router.navigate(['condition', 'developer', this.developerId]);
    });
  }

  calculatePercentFromShare(share: number, base: number): number {
    if (!share || !base) { return null; }
    return +(share * base).toFixed(5);
  }

  onSuccess(response) {
    this.notify.notifySuccess('Поздравляем', 'Данные успешно сохранены', 3000);
  }

  onError(error) {
    this.notify.notifyError('Ошибка', error, 5000);
  }

}
